import { render } from "./SectorPage.vue?vue&type=template&id=df101a5c"
import script from "./SectorPage.vue?vue&type=script&lang=js"
export * from "./SectorPage.vue?vue&type=script&lang=js"

import "./SectorPage.vue?vue&type=style&index=0&id=df101a5c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__